<div id="user-card" class="pb-3 rounded">
  <mat-card>
    <div class="card uc-card rounded">
      <div class="uc-card-img-block">
        <img class="img-fluid pravatar" [src]="currentUser?.profileData?.coverPhoto?.trim() || './assets/images/cover.jpg'">
      </div>
      <div class="uc-card-body pt-5">

        <div class="d-flex justify-content-between">
          <div class="uc-header">
            <div class="uc-avatar pr-cursor" routerLink="/{{currentUser?.handle}}">
              <img [src]="currentUser?.profileData?.photoURL?.trim() || './assets/images/profile.jpg'">
            </div>
          </div>
          <div class="uc-user mr-auto pr-cursor" routerLink="/{{currentUser?.handle}}">
            <h6 class="uc-name mr-1">{{currentUser?.profileData?.name}}</h6>
            <small class="text-success uc-username uc-cursor uc-truncate">@{{currentUser?.handle}}</small>
          </div>
        </div>

        <div class="uc-card-footer small">
          <div class="uc-card-stats">
            <div class="uc-card-stat" routerLink="/{{currentUser?.handle}}">
              <span class="value text-success uc-cursor">{{currentUser?.lightStats?.postsCount}}</span>
              <span class="label text-muted">Scrolls</span>
            </div>
            <div class="uc-card-stat" routerLink="/{{currentUser?.handle}}/followers">
              <span class="value text-success uc-cursor">{{currentUser?.connections?.followers}}</span>
              <span class="label text-muted">Followers</span>
            </div>
            <div class="uc-card-stat" routerLink="/{{currentUser?.handle}}/following">
              <span class="value text-success uc-cursor">{{currentUser?.connections?.following}}</span>
              <span class="label text-muted">Following</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-card>
</div>
